// i18n area 'tasks' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/tasks.sr-Latn-RS.meta.json.
import type { enUS } from './tasks'

export const srLatnRS: typeof enUS = {
  macrotasks: {
    title: 'Makrozadaci',
    subtitle: 'Složene operacije — mogu se nastaviti od neuspešnog koraka, ili prekinuti',
    colType: 'Tip',
    colTarget: 'Objekat',
    colPhase: 'Faza',
    colSteps: 'Koraci',
    empty: 'Nema makrozadataka',
    detail: 'Detalji',
    failedAt: 'neuspešan na',
    resume: 'Pokušaj ponovo od neuspešnog koraka',
    abort: 'Prekini sve',
    cancel: 'Otkaži',
    actionError: 'Akcija je odbijena'
  },
  tasks: {
    title: 'Zadaci',
    searchPlaceholder: 'Pretraži po tipu ili targetu',
    type: 'Tip',
    target: 'Target',
    phaseLabel: 'Faza',
    progress: 'Napredak',
    started: 'Započeto',
    finished: 'Završeno',
    node: 'Čvor',
    empty: 'Nema zadataka',
    loadError: 'Zadatke nije moguće učitati — da li je TVirt backend dostupan?',
    limboHint: "Čvor '{node}' nedostupan od {time} — zadatak drži write lease na svom targetu dok se čvor ne vrati ili ne bude atestiran kao ugašen",
    nodeAttested: 'Čvor atestiran kao ugašen',
    phase: {
      queued: 'U redu čekanja',
      running: 'U toku',
      succeeded: 'Završen',
      failed: 'Neuspešan',
      cancelled: 'Otkazan',
      'failed-at-step': 'Neuspešan na jednom koraku',
      aborted: 'Prekinut'
    },
    dropdown: {
      tooltip: 'Zadaci u toku',
      title: 'Zadaci u toku',
      empty: 'Nema zadataka u toku',
      viewAll: 'Vidi sve zadatke'
    },
    detail: {
      open: 'Detalji',
      scope: 'Opseg',
      message: 'Poruka',
      params: 'Parametri',
      result: 'Rezultat',
      errorTitle: 'Greška',
      steps: 'Koraci',
      failedAt: 'neuspešan na',
      superseded: 'prevaziđen',

      // Dialog standard (round #156): il posto del figlio nel piano del padre,
      // il padre stesso (apribile in-place) e il passo colpevole.
      step: 'Korak',
      parent: 'Roditeljski zadatak',
      failedStep: 'Neuspešan korak',
      log: 'Log',
      logEmpty: 'Još nema redova u logu',
      close: 'Zatvori'
    },
    actions: {
      cancel: 'Otkaži',
      resume: 'Pokušaj ponovo od neuspešnog koraka',
      abort: 'Prekini sve (undo završenih koraka)',
      refused: 'Akcija je odbijena'
    }
  },
  events: {
    loadError: 'Dnevnik nije mogao da se učita — da li je TVirt backend dostupan?',
    title: 'Događaji',
    subtitle: 'Istorijsko pamćenje klastera: svršene činjenice, od najnovijih',
    filterSeverity: 'Ozbiljnost',
    filterCategory: 'Kategorija',
    filterAll: 'Sve',
    searchLabel: 'Pretraga',
    searchPlaceholder: 'Pretraži ceo dnevnik',
    subjectFilter: 'Događaji za {subject} — prikaži sve',
    colAt: 'Kada',
    colSeverity: 'Ozbiljnost',
    colType: 'Tip',
    colSubject: 'Subjekt',
    colActor: 'Ko',
    colNode: 'Node',
    colMessage: 'Poruka',
    empty: 'Nema događaja',
    loadMore: 'Učitaj još',
    actorSystem: 'sistem',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID događaja',
    taskCollectedHint: 'Task ima kraću retenciju: kada se prikupi, link više ne odgovara',
    severity: {
      info: 'Informacija',
      warning: 'Upozorenje',
      error: 'Greška',
      critical: 'Kritično'
    },
    category: {
      lifecycle: 'Životni ciklus',
      config: 'Konfiguracija',
      availability: 'Dostupnost',
      security: 'Bezbednost'
    },
    type: {
      haNetsvcFailedOver: 'Failover mrežnog servisa',
      haNetsvcNoCandidate: 'Mrežni servis bez kandidat-čvora',
      haNetsvcReaped: 'Lokalna instanca požnjevena pri povratku',
      netsvcFloatipMoved: 'Plutajući IP premešten na drugog držaoca',
      netsvcFloatipNoHolder: 'Plutajući IP bez zdravog cilja',
      haAppFailedOver: 'Failover App instance',
      haAppNoCandidate: 'App instanca bez kandidata čvora',
      haAppStorageLocalSkip: 'App instanca nije prebačena: trajni podaci lokalni na mrtvom čvoru',
      haAppReaped: 'Lokalni pod App instance požnjeven pri povratku'
    }
  },
  audit: {
    loadError: 'Registar audita nije mogao da se učita — da li je TVirt backend dostupan?',
    title: 'Audit',
    subtitle: 'Ko je šta uradio, kada i nad kojim objektom — pokušane radnje, uključujući odbijanja',
    filterOutcome: 'Ishod',
    filterAll: 'Svi',
    filterSudo: 'Samo uzdignute radnje',
    colAt: 'Kada',
    colActor: 'Ko',
    colAction: 'Radnja',
    colTarget: 'Objekat',
    colOutcome: 'Ishod',
    colNode: 'Node',
    empty: 'Nema zabeleženih radnji',
    loadMore: 'Učitaj još',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Ruta',
    detailProblem: 'Razlog',
    detailTask: 'Task',
    detailClientIp: 'Odakle',
    detailId: 'ID zapisa',
    detailSession: 'Sesija',
    taskHint: 'Ishod prihvaćene radnje živi u dnevniku događaja, pod istim id-om taska',
    outcome: {
      succeeded: 'Uspelo',
      accepted: 'Prihvaćeno',
      denied: 'Uskraćeno',
      rejected: 'Odbijeno',
      failed: 'Neuspelo'
    }
  },
  notifications: {
    loadError: 'Obaveštenja nisu mogla da se učitaju — da li je TVirt backend dostupan?',
    actionError: 'Akcija je odbijena',
    title: 'Obaveštenja',
    subtitle: 'Odredišta prema kojima činjenice dnevnika napuštaju klaster',
    rulesTitle: 'Pravila',
    rulesSubtitle: 'Koje činjenice izlaze i kuda',
    deliveriesTitle: 'Isporuke',
    deliveriesSubtitle: 'Ishod svakog obaveštenja, sa razlogom kada ne uspe',
    colName: 'Naziv',
    colKind: 'Tip',
    colWhere: 'Kuda',
    colScope: 'Scope',
    colSeverity: 'Ozbiljnost',
    colMatch: 'Filter',
    colTargets: 'Odredište',
    colAt: 'Kada',
    colState: 'Stanje',
    colEvent: 'Događaj',
    colAttempts: 'Pokušaji',
    colOutcome: 'Ishod',
    empty: 'Nema redova',
    matchAll: 'sve činjenice',
    test: 'Isprobaj',
    testOk: 'Probno obaveštenje isporučeno na {target}',
    testFailed: 'Proba prema {target} nije uspela: {reason}',
    retry: 'Vrati u red',
    retried: 'Isporuka vraćena u red',
    grouped: 'i još {count} ponavljanja',
    state: {
      failed: 'Neuspela',
      pending: 'U redu',
      sending: 'Šalje se',
      sent: 'Poslata'
    },
    tabTargets: 'Odredišta',
    tabRules: 'Pravila',
    tabDeliveries: 'Dostave',
    targetCreateTitle: 'Novo odredište',
    ruleCreateTitle: 'Novo pravilo',
    nameHint: 'Mala slova, cifre i crtice; jedinstveno po opsegu',
    kindImmutableHint: 'Nepromenljivo: promena tipa znači kreiranje drugog odredišta',
    kindSmtp: 'Pošta (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Stanje',
    enabledOn: 'Aktivno',
    enabledOff: 'Zaustavljeno',
    smtpHost: 'SMTP server',
    smtpPort: 'Port',
    smtpPortHint: 'Uobičajeno: 25 bez TLS-a, 587 sa starttls, 465 sa tls',
    smtpSecurity: 'Bezbednost',
    smtpFrom: 'Pošiljalac',
    smtpTo: 'Primaoci',
    smtpToHint: 'Jedna ili više adresa razdvojenih zapetom',
    webhookUrl: 'URL',
    payload: 'Sadržaj',
    payloadHint: 'Sa minimal poruka i podaci događaja ne izlaze iz klastera',
    credential: 'Akreditiv',
    credentialNone: 'Nema',
    credentialHintSmtp: 'Račun releja iz skladišta ključeva; nema znači anonimni SMTP',
    credentialHintWebhook: 'Tajna za potpisivanje iz skladišta ključeva; bez potpisa svako ko zna URL može se predstaviti kao klaster',
    minSeverityHint: 'Prag, ne skup: od ove težine i više',
    categories: 'Kategorije',
    categoriesHint: 'Prazno = sve',
    types: 'Tipovi događaja',
    typesHint: 'Razdvojeni zapetom; prazno = svi. Nepoznat tip se odbija',
    targetsHint: 'Najmanje jedno; moraju biti u opsegu pravila ili u njegovom pretku',
    recursiveOn: 'I podređeni opsezi',
    recursiveOff: 'Samo ovaj opseg',
    recursiveHint: 'Resursi žive u listovima: bez dece pravilo na korenu obaveštava gotovo ništa',
    repeatWindow: 'Prozor grupisanja (s)',
    repeatWindowHint: 'Unutar prozora ponavljanja ne šalju poštu: broje se na prvom. 0 isključuje',
    targetInUseError: 'Odredište {name} još koristi jedno pravilo'
  }
}
